module.exports = __webpack_public_path__ + "img/icon-badge.0b70752f.svg";